<div class="jobseeker-language-info">
  <h3>
    {{ 'label.Languages' | translate }}
  </h3>
  <div class="divider"></div>
</div>
<hr-jobseeker-language-item
  *ngFor="let item of jobseeker?.languages"
  [language]="item"
  [worldLanguages]="worldLanguages"
  [languageproficiencyLevelList]="languageproficiencyLevelList"
  (onCancelEdit)="onCancelLanguageEdit()"
  (onUpdate)="onSaveLanguage()"
></hr-jobseeker-language-item>
<hr-jobseeker-language-item
  *ngIf="isAddModeOn"
  [isInEditMode]="isAddModeOn"
  [language]="newLanguage"
  [worldLanguages]="worldLanguages"
  [languageproficiencyLevelList]="languageproficiencyLevelList"
  (onCancelEdit)="onCancelLanguageAdd()"
  (onUpdate)="onLanguageAdded()"
></hr-jobseeker-language-item>
<button
  class="fa fa-plus btn btn-default"
  type="button"
  (click)="onAddClick()"
  *ngIf="!isAddModeOn"
>
  {{ 'label.Add' | translate }}
</button>
